import { styled } from "@mui/material";
import Paper from "components/mui5/Paper";

export const MetricCellPaper = styled(Paper)({
  backgroundColor: "#FAFAFA",
});
